'use strict';

module.exports.classic = require('./classic');



//////////////////
// WEBPACK FOOTER
// ./src/schema/index.js
// module id = 35
// module chunks = 0